import request from '../../utils/request';

export default params => request('/receptacles/history', { params });
